import * as actionTypes from '../../../constants/actionTypes';
import * as ActionTypes from "../../../constants/actionTypes";

const initialState = {
  featuresFiltersVisible: false,
  allFilterGroups: [],
  filtersReceived: {}, // {"Bathtub: [], "Countertops": [], etc.}
  selectedFilters: [],
  expandedFilters: [],
  filterVisible: ''
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FEATURES_FILTERS_TOGGLE_FEATURES_FILTERS_VISIBLE:
    case actionTypes.FEATURES_FILTERS_SET_ALL_AVAILABLE_FILTERS:
    case actionTypes.FEATURES_FILTERS_SET_VISIBLE_FILTERS:
      return Object.assign({}, state, {
        ...action.payload
      });
    case actionTypes.FEATURES_FILTERS_SET_EXPANDED_FILTERS:
      return Object.assign({}, state, {
        expandedFilters: [...action.payload.expandedFilters]
      });
    case actionTypes.FEATURES_FILTERS_SET_SELECTED_FILTERS:
      return Object.assign({}, state, {
        selectedFilters: [...action.payload.selectedFilters]
      });
    case actionTypes.FEATURES_FILTERS_SET_GROUP_AVAILABLE_FILTERS:
      return Object.assign({}, state, {
        filtersReceived: {
          ...state.filtersReceived,
          [action.payload.groupName]: action.payload.filters
        }
      });
    case ActionTypes.FEATURES_SETUP_CLEAR:
      return Object.assign({}, state, {
        expandedFilters: [],
        selectedFilters: [],
        filterVisible: "",
        featuresFiltersVisible: false,
      });

    default:
      return state;
  }
}
